import React from 'react';
import { OrbitComponent } from '../../../base-components/orbit-component/orbit-component';
import { observer } from 'mobx-react';
import { SearchGameItemBox } from './boxes/search-game-item/search-game-item.box';
import { ISearchSuggestion } from '../../../../services/game-search/game-search-result';
import { GameImageComponent } from '../../../single-game/common/parts/game-image/game-image.component';
import { HighlightSearchListItemComponent } from '../highlight-search-list-item/highlight-search-list-item.component';
import { SearchTextWrapperBox } from './boxes/search-text-wrapper/search-text-wrapper.box';


export interface SearchGameItemComponentProps {
    searchSuggestion: ISearchSuggestion;
}
  

@observer
export class SearchGameItemComponent extends OrbitComponent<SearchGameItemComponentProps> {

    private _onClickHandler = () => {
        this.services.gameSearch.closeSearchResult();
        this.services.userMenu.closeMenu();
        this.services.sideMenu.closeMobileMenu();
        this.props.searchSuggestion.executeAction();
    };

    render() {
        return (
            <SearchGameItemBox className={'cy-search-game-item'} onClick={this._onClickHandler}>
                <GameImageComponent gameInfo={this.props.searchSuggestion.gameInfo} useLazyLoading={false}/>
                <SearchTextWrapperBox>
                    <HighlightSearchListItemComponent gameName={this.props.searchSuggestion.text} />
                </SearchTextWrapperBox>
            </SearchGameItemBox>
        );
    }
}
